module.exports = __webpack_public_path__ + "static/media/volunteer-patjarmerah-solo.4a7d2e84.jpg";